<template>
	<div>
		<dv-full-screen-container>
			
			<dv-loading v-if="loading">Loading...</dv-loading>
			
			<div id="bmap" class="bmap_comtainer"></div>
			
			<<div class="title_container">
				<div style="width: 100%;display: flex;flex-direction:row;">
					<dv-decoration-10 style="width:30%;height:.0625rem;padding-top: 0.1rem" />
					<dv-decoration-10 style="width:40%;height:.0625rem;visibility: hidden;padding-top: 0.1rem" />
					<dv-decoration-10 style="width:30%;height:.0625rem; transform: rotateY(180deg);padding-top: 0.1rem" />
				</div>
				<img class="logo-title" :src="logo" />
				<div v-if="currentTab == 1" class="selectchoose">
					<select v-model="selectedChooseCar" class="selector" @change="handleSelectCar()">
					      <option value="null">--请选择机器人--</option>
					      <option v-for="(item, index) in carList" :key="index" :value="item">{{ item.name }}</option>
					</select>
				</div>
				<div class="title">
					<dv-decoration-8 :color="['#568aea', '#568aea']" style="width:2.5rem;height:.625rem;" />
					<p id="entity" class="title_text">{{logoTitle}}</p>		
					<dv-decoration-8 :reverse="true" :color="['#568aea', '#568aea']" style="width:2.5rem;height:.625rem;" />
				</div>
				<div class="date">
					<div class="row1">
						<img :src="weathericon" style="height: .3rem;padding-right: .2rem;" />
						<div class="title_text">{{dateYear}} {{dateWeek}} {{dateDay}}</div>						
					</div>
					<div  class="row1" style="justify-content: flex-end;">
						<div v-if="currentTab == 1" class="back_text" v-on:click="backTabEntity" >返回</div>
						<div class="btn_text" v-on:click="logout">退出</div>
						<div class="btn-fullscreen" @click="toggleFullScreen">
							<img v-if="isFullscreen == false" src="../assets/img/screen_full.png" class="img1" style="height: .25rem;" />
							<img v-if="isFullscreen == true"  src="../assets/img/screen_cancel.png" class="img2" style="height: .25rem;" />
						</div>
					</div>
				</div>	
			</div>	
			
			<div class="body_container">
				<div v-if="currentTab == 0">	
					<vLeftE :selectedEntity="entitychoose" :mqttRealAlarm="mqttAlarm"></vLeftE>
					<vRightE :selectedEntity="entitychoose" ></vRightE> <!--  v-if="entityid == 1" -->
					<vTopE :selectedEntity="entitychoose"></vTopE>
				</div>
				<div v-if="currentTab == 1">
					<vLeftC :selectedCarInfo="carchooseinfo" 
						:mqttRealData="mqttRealtime" :mqttRealOrder="mqttWkOrder"  :mqttRealAlarm="mqttAlarm"></vLeftC>
					<vRightC :selectedCar="carchooseinfo" ></vRightC>	 <!--  :selectedCar="carchoose" -->
					<vBottomC :selectedCar="carchoose" ref="carBottomCompon" 
						:mqttTakePic="mqttTakePic" :mqttRemoteOver="mqttCtlRsp" :mqttRemoteOverPic="mqttCtlPic"
						:mqttRealOrder="mqttWkOrder" :mqttRealData="mqttRealtime"  ></vBottomC>				<!--   :selectedCar="carchoose" -->
				</div>
				<div class="aniTrack_container" v-show="trackAniFlag == true">
					<el-button type="success" size="mini" class="btn3" v-on:click="continueAni()">继续</el-button>
					<el-button type="danger" size="mini" class="btn3" v-on:click="pauseAni()">暂停</el-button>
				</div>
			</div>
		</dv-full-screen-container>		
	</div>
</template>

<script src="../assets/js/infobox.js"></script>
<script>
	import screenfull from "screenfull";
	import Vue from 'vue/dist/vue.esm.js'
	import {BMPGL} from '../components/baidu-map-gl.js'
	// import BMapLib from 'vue-baidu-map'
	import {BaiduMap} from 'vue-baidu-map'
	import {formatTime} from '../utils/time.js'
	import mqttHandle from '../components/mqttHandler.js'
	
	import vLeftE from './entity/left.vue'
	// import vBottomE from './entity/bottom.vue'
	import vRightE from './entity/right.vue'
	import vTopE from './entity/top.vue'
	
	import vBottomC from './car/bottom.vue'
	import vRightC from './car/right.vue'
	import vLeftC from './car/left.vue'
	
	import titImg from '../assets/img/tit.png'
	import mapicon_gs from '../assets/img/icon_map_entity_6.png'
	import mapicon_carline from '../assets/img/carline_2.png'
	import mapicon_caroff from '../assets/img/caroff_2.png'
	import carImg from '../assets/img/car_s142.png'
	import carlinear from '../assets/img/carlinear.png'
	
	import {getIndexEntityMap} from '../api/entity.js'
	import {getIndexCarMap,getCarTraj} from '../api/car.js'
	
	// import axios from 'axios'
	
	let bmap,markerInfoWindow = null,trackAni;
	let bmlLushu_path = [], bmlLushu_play = false;
	
	var mqtt; //mqtt 处理对象（全局变量）
	var mqttClient ; 
	var mqttTopic = "service/adt/+/realtime",topic_resp_adt,topic_resp_acu,topic_danger_acu,
		mqttTopics;
		
	export default{
		components: {
			vLeftE,
			// vBottomE,
			vRightE,
			vTopE,
			
			vBottomC,
			vRightC,
			vLeftC
		},
		mounted() {
			this.initEntity()
			this.timeFn()
			this.initMqtt()
			this.initFullScreen()
		},
		created() {
			
		},
		provide() {
			return {
				mqttWorkExecute: this.mqttWorkExecute,
				executeWorkDetailSwitch:this.executeWorkDetailSwitch,
				updateWeather:this.updateWeather,
				warnDetailSwitch:this.warnDetailSwitch
			}
		},
		destroyed(){
			this.closeMqtt()
		},
		data(){
			return{
				// logoTitle:'兰大智能清洁机器人调度中心' ,//萝卜牛智慧调度中心
				// logo:require('../assets/img/roboy-lzdx.png'),			
				logoTitle:localStorage.getItem('logoTitle')  == null
					? '萝卜牛智慧调度中心': localStorage.getItem('logoTitle')  == 'null'
						?  '萝卜牛智慧调度中心': localStorage.getItem('logoTitle')  == 'undefined' 
							? '萝卜牛智慧调度中心' : localStorage.getItem('logoTitle')+'调度中心', 
				logo:localStorage.getItem('logoMenu')  == null
					? require('../assets/img/logo_large2.png') : localStorage.getItem('logoMenu')  == 'null' 
						? require('../assets/img/logo_large2.png') : localStorage.getItem('logoMenu')  == 'undefined' 
							? require('../assets/img/logo_large2.png') : localStorage.getItem('logoMenu'),			
				loading:true,
				dateDay: null,
				dateYear: null,
				dateWeek: null,
				weekday: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
				isFullscreen: false,
				
				currentTab:0, // 0-运营点信息页 1-车辆信息页
				
				entityList:[],
				carList:[],
				trackAniFlag:false,
				loginuser:localStorage.getItem('username'),
				
				entityid:localStorage.getItem('entityid'),
				entitychoose:localStorage.getItem('entityid'),
				carchoose:null,
				carchooseinfo:{
					carid:null,
					cartype:null,
					num4g:'',
					active4g:'',
					numDiffer:'',
					activeDiffer:''
				},
				
				mqttReceives:'',
				mqttRealtime:null,
				mqttWkOrder:null,
				mqttAlarm:null,
				mqttTakePic:null,				
				mqttCtlRsp:null,
				mqttCtlPic:null,
				
				selectedChooseCar:null,			
				
				workingdetailFlag:false,
				workingdetailinfo:null,
				workingtype:0,
				
				weathericon:require('../assets/img/weather/weather-sun.png'),	
				
				workingdetailinfoFlag:false
			}
		},
		methods:{
			/**加载运营点信息**/
			initEntity(){	
				let that = this
				getIndexEntityMap(that.entityid).then(res=>{
					if(res.result == 0){
						if(res.entityMapList!=null && res.entityMapList.length > 0){
							that.entityList = res.entityMapList						
						}					
						that.initBMap()
					}else{
						that.$message({
							message: '未获取到运营单位地图信息',
							type: 'error'
						});
						that.entityList = []
					}
				});
			},
			/** 加载车辆信息 **/
			initCar(entityid){	
				let that = this
				getIndexCarMap(entityid).then(res =>{
					if(res.result == 0){
						if(res.carMapList.length  > 0){
							that.carList = res.carMapList
							bmap.clearOverlays();
							that.addMarker(2)
						}
					}else{
						that.$message({
							message: '未获取到机器人信息',
							type: 'error'
						});
					}
				});
			},
			/** tab切换 **/
			mapTabSwitch(){				
				bmap.closeInfoWindow()
				this.currentTab = this.currentTab == 0 ? 1 : 0
			},
			mqttWorkExecute(workmqtt){
				var pubtopic = "service/app/"+this.carchoose+"/request";
				this.mqttPublishHandler(pubtopic,workmqtt)
			},
			executeWorkDetailSwitch(wktype,workingdetail){
				var workingcarid , workingentityid ;
				if(wktype == 1){
					workingcarid = workingdetail.deviceId
					workingentityid = workingdetail.entityId
				}else{
					 workingcarid = workingdetail.carId
					 workingentityid = workingdetail.entityId
				}

				this.setCurrentEntity(workingentityid)
				this.mapTabSwitch()
				
				this.workingdetailinfoFlag = true
				this.workingtype =	wktype				
				this.workingdetailFlag = true
				this.workingdetailinfo = workingdetail
				this.initCar(workingentityid)
				this.carchooseinfo.carid = workingcarid
				
				// var len = this.carList.length
				// if(len > 0){
				// 	for(var i = 0 ; i ++ ; i < len){
				// 		var item =  this.carList[i]
				// 		if(item.id == workingcarid){
				// 			this.selectedChooseCar = item
				// 			this.handleSelectCar()
							
				// 			this.$refs.selectedWork = workingdetail
				// 			this.$refs.carBottomCompon.handleSelectWork()
				// 			return
				// 		}
				// 	}
				// }				
			},
			updateWeather(icon){
				this.weathericon = icon
			},
			warnDetailSwitch(warnEntity,warnCar,warnWork,warnPic){
				this.setCurrentEntity(warnEntity)
				this.mapTabSwitch()
				
				this.workingdetailFlag = true
				this.workingdetailinfo = {
					carId : warnCar
				}
				if(warnWork != null){
					this.workingdetailinfoFlag = true
					this.workingtype =	warnWork.wktype					
					this.workingdetailinfo =warnWork.workingdetail
				}			
				this.initCar(warnEntity)
				this.carchooseinfo.carid = warnCar
				if(warnPic){
					this.$nextTick(() => this.$refs.carBottomCompon.entyWarnToShowPic()) 
				}
			},
			initMqtt(){
			  let that = this
			  topic_danger_acu = 'service/adt/'+this.loginuser+'/danger'
			  mqttTopics = ["service/adt/+/realtime",topic_danger_acu];
			  //创建链接，接收数据
			  mqtt = new mqttHandle(mqttTopics,this.loginuser);
			  mqttClient = mqtt.createConnect();
			  mqttClient.on("message", (topic, message) => {
				//数据分类
				try {
				  that.mqttReceives = that.mqttReceives.concat(message);
				  that.mqttReceiveHandler(topic, message);
				} catch (error) {}
			  }) 
			},
			closeMqtt() {
			    if (mqttClient != null) {
			        mqttClient.unsubscribe(mqttTopics)
					mqttClient.end()
			        mqttClient = null
			    }
			},
			mqttReceiveHandler(topic, resInfo) { // loginuser
				var topic_selectedcar = 'service/adt/'+this.carchoose+'/realtime';
				if(topic == topic_selectedcar){
					var mqttmsg = JSON.parse(resInfo)
					this.mqttMessageHandler(1,mqttmsg)
				}else if(topic == topic_resp_adt){
					var mqttmsg_rsp_adt = JSON.parse(resInfo)
					this.mqttMessageHandler(2,mqttmsg_rsp_adt)
				}else if(topic == topic_resp_acu ){ // topic_resp_acu topic.startsWith('service/adt') && topic.endsWith('feedback')
					var mqttmsg_rsp_acu = JSON.parse(resInfo)
					this.mqttMessageHandler(3,mqttmsg_rsp_acu)						
				}else if(topic == topic_danger_acu){ // topic.startsWith('service/adt') && topic.endsWith('danger')
					var mqttmsg_danger_acu = JSON.parse(resInfo)
					this.mqttMessageHandler(4,mqttmsg_danger_acu)
				}
			},
			mqttPublishHandler(topic,msg){
				mqttClient.publish(topic,JSON.stringify(msg),0,error => {
					if(!error){
						console.log("mqttPublish-sucs")
						this.$message({
							type: 'success',
							message: '下发成功'
						});
						topic_resp_adt = 'service/adt/'+this.carchoose+'/reply_app'
						this.mqttSubscribe(topic_resp_adt)
					}
				})
			},
			mqttMessageHandler(type,mqttmsg){
				let that = this
				if(type == 1){
					var tskid = mqttmsg.taskId
					var payload = mqttmsg.payload
					switch(tskid){
						case 0:
							 that.mqttWkOrder = payload
							 break;
						case 1:
							that.mqttAlarm = payload
							break;
						case 2:
							that.mqttRealtime= payload
							break;	
						case 3:
						    that.mqttCtlRsp= payload
							break;
						default:
						  break;
					}
				}else if(type == 2){
					var source = mqttmsg.source
					if(source == 2){
						var rs = mqttmsg.result
						var msg = mqttmsg.message
						this.$message({
							type: 'info',
							message: mqttmsg.message
						});
						
						var tsk = mqttmsg.taskId
						if(rs == 0){
							if(tsk == 3){
								// topic_danger_acu =  'service/adt/+/danger';
								// this.mqttSubscribe(topic_danger_acu)
							}else if(tsk == 2){
								topic_resp_acu =  'service/adt/'+this.loginuser+'/feedback';
								this.mqttSubscribe(topic_resp_acu)
							}							
						}
						this.mqttUnSubscribe(topic_resp_adt)
					}
				}else if(type == 3){
					var source = mqttmsg.source
					if(source == 2){
						var fbcar = mqttmsg.RobotID
						if(this.carchoose == fbcar){
							var msg = mqttmsg.Feekback.result
							this.$message({
								type: 'info',
								message: msg
							});						 
							this.mqttUnSubscribe(topic_resp_acu)
							
							var picinfo = mqttmsg.Feekback.picInfo
							if(picinfo != null){
								that.mqttTakePic = picinfo
							}							
						}
					}
				}else if(type == 4){
					var dangerCar = mqttmsg.RobotID
					if(this.carchoose == dangerCar){
						var picReason = mqttmsg.Danger.fileInfo
						if(picReason == 5){
							that.mqttCtlPic = mqttmsg.Danger.picInfo
						}					
					}				
				}///
			},
			mqttSubscribe(topicsub){
				mqttClient.subscribe(topicsub, { qos: 0 // 这儿直接EMQ的qos对应的就好了
				}, (error,res) => {
					if (error) {
					    console.log('subscribe error', error);
					    return;
					}
					console.log(topicsub+':subscribe success');				   
				})
			},
			mqttUnSubscribe(topicunsub){
				mqttClient.unsubscribe(topicunsub, error => {
				    if (error) {
				      console.log('Unsubscribe error', error)
				    }
					console.log(topicunsub+':Unsubscribe success');	
				})
			},
			/** 加载地图 **/
			initBMap(){
				let _this = this
				var lng = _this.entityList[0].baiduLongitude,lat = _this.entityList[0].baiduLatitude
				BMPGL().then(BMapGL => {
					bmap = new BMapGL.Map("bmap");
					bmap.centerAndZoom(new BMapGL.Point(lng,lat), 8); 
					//设置中心点、缩放级别19
					bmap.enableScrollWheelZoom(true); //设置滚轮缩放
					// bmap.setHeading(64.5); // 设置旋转角
					bmap.setTilt(53); //设置倾斜角
					bmap.setDisplayOptions({ //设置天空颜色
					    skyColors: ['rgba(42, 153, 193, 0.0)','rgba(49, 123, 193, 0.2)']
					});
					bmap.setMapStyleV2({  // 设置地图样式   
					  // styleId: 'd805c40c48ca0166abf7a85fc08ed250',
						// styleId: '70df5bf2668a8e2417ccc0e6e9731aeb'
					});
					
					bmap.clearOverlays();			
					_this.addMarker(1)					
					
					_this.loading = false
					localStorage.setItem('entityLng',lng)
					localStorage.setItem('entityLat',lat)
					// this.getWeather()
				})			
			},
			/** 添加标记 **/
			addMarker(type){
				let that = this
				if(type == 1){
					if(that.entityList!=null && that.entityList.length > 0){
						that.entityList.forEach((item,index) =>{
							// 创建图标(宽，高)
							var myIcon = new BMapGL.Icon(mapicon_gs, new BMapGL.Size(48, 49),{anchor: new BMapGL.Size(40, 40)});
							// 创建Marker标注，使用图标
							var pt = new BMapGL.Point(item.baiduLongitude, item.baiduLatitude);
							var marker1 = new BMapGL.Marker(
								pt, {icon: myIcon},
							);
							// 绑定信息
							marker1.data = item
							
							// marker1.id = item.id						
							// marker1.clickEvent = that.onMarkerClick	
							// 点标记添加点击事件
							marker1.addEventListener('click',that.onMarkerClick);
							marker1.massClear="disableMassClear"
							// 将标注添加到地图
							bmap.addOverlay(marker1);	
						})
					}
				}else{
					if(that.carList!=null && that.carList.length > 0){
						
						// bmap.setZoom(19)					
						var point = new BMapGL.Point(that.carList[0].baiduLongitude,that.carList[0].baiduLatitude);
						// bmap.setCenter(point);
						bmap.centerAndZoom(point, 26); 
						
						var points = new Array(); //存放标注点经纬信息的数组
						var markers = new Array(); //存放标注点对象的数组
						that.carList.forEach((item,index)=>{	
							
							let iconurl = item.status == 0 ? mapicon_carline : mapicon_caroff						
							let mapicon = new BMapGL.Icon(iconurl, new BMapGL.Size(48, 49), { // 24,25   20,20
						          anchor: new BMapGL.Size(40, 40),
						      });
						
							var pt = new BMapGL.Point(item.baiduLongitude, item.baiduLatitude)
							var marker2 = new BMapGL.Marker(
								pt, {icon: mapicon},
							);		
							marker2.id = item.id
							marker2.data = item							
							marker2.clickEvent = that.onMarkerClick											
							marker2.addEventListener('click',that.onMarkerClick);
							marker2.massClear="disableMassClear"
							bmap.addOverlay(marker2);													
																								
							if(that.workingdetailFlag){
								if(item.id == that.workingdetailinfo.carId || item.id == that.workingdetailinfo.deviceId){
									
									var point = new BMapGL.Point(item.baiduLongitude,item.baiduLatitude);
									bmap.centerAndZoom(point, 26); 

									var data = {
										data:item,
										latLng: new BMapGL.Point(item.baiduLongitude, item.baiduLatitude)
									}
									var e = {
										target:data
									}
									marker2.clickEvent(e)
												
									// that.$refs.carBottomCompon.selectedWork = that.workingdetailinfo
									// that.$refs.carBottomCompon.handleSelectWork()								
									if(that.workingdetailinfoFlag){
										that.$refs.carBottomCompon.workingdetailFlag = true
										that.$refs.carBottomCompon.workingdetailInfo = that.workingdetailinfo
										that.$refs.carBottomCompon.workingtype = that.workingtype
									}///								
								}
							}//					
						})
					}
				}					
			},
			/** **/
			backTabEntity(){
				this.loading = true
				this.currentTab = 1
				this.mapTabSwitch()
				
				this.selectedChooseCar = null
				this.carchoose = null
				this.carchooseinfo.carid = null
				
				this.trackAniFlag = false
				this.trackAni = null
				
				this.workingdetailFlag = false
				this.workingdetailinfo = null
				
				this.entityid = localStorage.getItem('entityid')
				this.entitychoose = localStorage.getItem('entityid')
				// this.initEntity()
				
					
				var entityLng = localStorage.getItem('entityLng') == null ? '119.955271' : localStorage.getItem('entityLng'),
				entityLat = localStorage.getItem('entityLat') == null ? '31.831686'  : localStorage.getItem('entityLat')			
				bmap.clearOverlays();
				bmap.centerAndZoom(new BMapGL.Point(entityLng,entityLat), 8); 
				this.addMarker(1)		
				this.loading = false
				
				//调用子页面方法
				// this.$refs.carInstant.clearCarInfo();
			},			
			/** 选择车辆信息 **/
			setCurrentCarInfo(carinfo){
				this.carchooseinfo.carid = carinfo.id
				this.carchooseinfo.num4g = carinfo.num4g
				this.carchooseinfo.active4g = carinfo.active4g
				this.carchooseinfo.numDiffer = carinfo.numDiffer
				this.carchooseinfo.activeDiffer = carinfo.activeDiffer
				this.carchooseinfo.cartype = carinfo.typeId
			},
			/** 选择车辆 **/
			setCurrentCar(curcarid){
				this.carchoose = curcarid	
			},
			/** 选择运营单位 **/
			setCurrentEntity(curentityid){
				this.entitychoose = curentityid
			},		
			handleSelectCar(){
				if(this.trackAniFlag == true){
					this.pauseAni()
					this.trackAniFlag = false
				}
				
				var carid = this.selectedChooseCar.id
				this.setCurrentCar(carid)
				this.setCurrentCarInfo(this.selectedChooseCar)
			
				var markerOverlays = bmap.getOverlays()
				markerOverlays.forEach((item,index)=>{
					if(item.id === carid){
						var e = {target:item}
						item.clickEvent(e);
						return;
					}
				})	
				
				// this.initAni(carid)						
			},
			/** 标记点击事件 **/
			onMarkerClick:function(e){				
				let _this = this						
				var info = e.target.data			
				if(info.type == 1){
					_this.setCurrentEntity(info.id)
				}else if(info.type == 2){ 	
					if(_this.trackAniFlag == true){
						_this.pauseAni()
						_this.trackAniFlag = false
					}
					_this.selectedChooseCar = info
					// _this.handleSelectCar()		
					_this.setCurrentCar(info.id)
					_this.setCurrentCarInfo(info)	
					
					// _this.initAni(info.id)
				}
				
				// 创建信息窗口
				var opts = {width: 320,height: 178};						
				markerInfoWindow = new BMapGL.InfoWindow( _this.getInfoBoxContent(info), opts);
				bmap.openInfoWindow(markerInfoWindow, e.target.latLng); // 开启信息窗口		
				
			},
			/** 添加信息窗体 **/
			getInfoBoxContent(info){
				
				let _this = this		
				var infoWindowContent = Vue.extend({
					template: `
						<div v-if=' ${info.type} == 1' style="margin:0;line-height:.1rem;">
						    <div>
							    <div class='alertimg'>
									<img src='${titImg}' style='height:.2rem;' />
									<img src='${titImg}' style='height:.2rem;' />
									运营点介绍
								</div>
								<table style='min-width:6rem;line-height:.1rem;color: #fff; font-size:.15rem;padding-top:.2rem;'>
									<tr>
										<td style='text-align:left;width: 20%' >
											<img src='${info.netPic}' style='height:1.5rem;width: 3rem;' />
										</td>
										<td>
											<tr>
												<td style='text-align:left;'>
													<p style='color: #fff;font-weight:bold;line-height: .3rem'>${info.name}</p>
													<div style='color: #fff;line-height: .2rem; white-space: break-spaces'>${info.desc}</div>
												</td>
											</tr>
											 <tr>
											 	<td style='text-align:center;'>
											 		<button @click='initCarInfo(\"${info.id}\")' 
														class='btnAni'>查看机器人</button>
											 	</td>
											 </tr>											 
										</td>
									</tr>							
								</table>
						    </div>
						</div>
										
						<div v-else style="margin:0;line-height:.1rem;">
						    <div>
							    <div class='alertimg'>
									<img src='${titImg}' style='height:.2rem;' />
									<img src='${titImg}' style='height:.2rem;' />
									机器人介绍
								</div>
								<table style='min-width:6rem;line-height:.1rem;color: #fff; font-size:.15rem;padding-top:.2rem;'>
									<tr>
										<td style='text-align:left;width: 20%' >
											<img src='${carImg}' style='height:1.5rem;' />
										</td>
										<td>
											<tr style='line-height: .3rem;font-size: .15rem;'>
												<td style='text-align:left;'>
													机器人id		
												</td>
												<td style='text-align:left;'>
													${info.id}	
												</td>
												<td></td>
												<td></td>
											</tr>
											<tr style='line-height: .3rem;font-size: .15rem;'>
												<td style='text-align:left;'>
													所属单位		
												</td>
												<td colspan='3' style='text-align:left;'>
													${info.entityName}	
												</td>
												<td></td>
												<td></td>
											</tr>
											<tr style='line-height: .3rem;font-size: .15rem;'>
												<td style='text-align:left;'>
													机器人名称		
												</td>
												<td style='text-align:left;'>
													${info.name}	
												</td>
												<td></td>
												<td></td>
											</tr>
											<tr style='line-height: .3rem;font-size: .15rem;'>
												<td style='text-align:left;'>
													规格型号		
												</td>
												<td style='text-align:left;'>
													${info.modelName}	
												</td>
												<td style='text-align:left;'>
													尺寸大小		
												</td>
												<td style='text-align:left;'>
													${info.size}	
												</td>
											</tr>
											<tr style='line-height: .3rem;font-size: .15rem;'>
												<td style='text-align:left;'>
													水箱容积		
												</td>
												<td style='text-align:left;'>
													${info.weight}	L
												</td>
												<td style='text-align:left;'>
													垃圾箱容积		
												</td>
												<td style='text-align:left;'>
													${info.maxWeight} L	
												</td>
											</tr>
											 <tr>
											 	<td style='text-align:center;'>
											 		<button @click='initCarTrack(\"${info.id}\")' class='btnAni'>今日轨迹</button>
											 	</td>
											 </tr>											 
										</td>
									</tr>							
								</table>
						    </div>
						</div>				
					`,
					methods:{
						initCarInfo(entityid){				
							_this.currentTab = 0
							_this.mapTabSwitch()
							_this.initCar(entityid)
						},
						initCarTrack(carid){
							_this.initAni(carid)
							// _this.bmapLushuStart(carid)
						}
					}
				})
				let component = new infoWindowContent().$mount()
				return component.$el	 
			},
			/** 轨迹加载 **/
			initAni(carid){			
				// var trajlsttest = [{
				//     'baiduLongitude': 116.297611,
				//     'baiduLatitude': 40.047363
				// }, {
				//     'baiduLongitude': 116.302839,
				//     'baiduLatitude': 40.048219
				// }, {
				//     'baiduLongitude': 116.308301,
				//     'baiduLatitude': 40.050566
				// }, {
				//     'baiduLongitude': 116.305732,
				//     'baiduLatitude': 40.054957
				// }, {
				//     'baiduLongitude': 116.304754,
				//     'baiduLatitude': 40.057953
				// }, {
				//     'baiduLongitude': 116.306487,
				//     'baiduLatitude': 40.058312
				// }, {
				//     'baiduLongitude': 116.307223,
				//     'baiduLatitude': 40.056379
				// }];
				var newindex = 0;//最新点的索引						
				getCarTraj(carid).then(res =>{
					let that = this
					
					if(trackAni!=null){//删除折线
						var allOverlay = bmap.getOverlays();
						for (var i = 0; i < allOverlay.length; i++){
							// if(allOverlay[i].toString().indexOf("Marker") > 0){//删除标志点 Polyline删除折线
							// 	bmap.removeOverlay(allOverlay[i]);
							// }
							if(allOverlay[i].massClear != "disableMassClear"){
								bmap.removeOverlay(allOverlay[i]);
							}
						}
					}
					
					if(res.result == 0){
						let trajlst = res.carTrajList 
						if(trajlst!=null && trajlst.length > 3){
							let linePoints = [];					
							for (let i = 1; i < trajlst.length; i++) {
							  var lng = trajlst[i].baiduLongitude;
							  var lat = trajlst[i].baiduLatitude;
							  var mode = trajlst[i].driveMode
							  
							  if (lng == 0 || lat == 0) {
							    continue;
							  }
							  // var points = [] 
							  // points[i] = new BMapGL.Point(x, y);
							  // linePoints.push(points[i]);
								let point = {
									lng:lng,
									lat:lat,
									mode:mode
								}
								linePoints.push(point)
							}
							
							// 将点转换为BMapGL.Point对象数组
							var path = linePoints.map(function(point) {
							    return new BMapGL.Point(point.lng, point.lat);
							});
							
							var len_path = linePoints.length 
							if(linePoints == null || len_path == 0){							
								 this.$message({
								   message:"轨迹数据长度不够",
								   type: 'warn'
								 });
								 return;
							}
							
							let polyline = new BMapGL.Polyline(path, { //linePoints
							  strokeColor: "#948b84",
							  strokeWeight: 8
							});
							
							linePoints.forEach((point, index) => {
							    if (index > 0) { // 第一点没有前一个点来比较速度，所以不设置颜色
							        var color = this.getColorByMode(point.mode); // 获取当前点的颜色							
									
									var subPath = path.slice(index - 1, index + 1); // 获取当前点和前一个点的路径段（实际上是单个点）
									var subPolyline = new BMapGL.Polyline(subPath, {strokeColor: color, strokeWeight: 5, strokeOpacity: 0.8});
									bmap.addOverlay(subPolyline); // 将子轨迹添加到地图上
							    }
							})
							
							
							// bmap.addOverlay(polyline);
							
							// let myIcon = new BMapGL.Icon(require('../assets/img/car_track.png'), new BMapGL.Size(45, 46), {
							//    imageSize: { width: 45, height: 45} , offset: new BMapGL.Size(25, 45) },
							//    );
							let markerS = new BMapGL.Marker(linePoints[0]); // new BMapGL.Marker(linePoints[0], {icon: myIcon});
							var labelS = new BMapGL.Label('起点',{offset:new BMapGL.Size(-15,2)});
							labelS.setStyle({
								background:'green',color:'white',border:'1px solid',fontSize:'12px',padding:'5px'
							});
							markerS.setLabel(labelS);			
							bmap.addOverlay(markerS);
							
							// if(newindex < len_path){
							// 	for(var i = 1 ; i < len_path ; i ++){
							// 		var tempPoints = [];
							// 		tempPoints.push(linePoints[i-1]);
							// 		tempPoints.push(linePoints[i]);
							// 		bmap.setViewport(linePoints[i-1])
							// 		var pl = new BMapGL.Polyline(tempPoints);
							// 		trackAni = new BMapGLLib.TrackAnimation(bmap, pl, {
							// 		    overallView: i === len_path-1,  // 动画完成后自动调整视野到总览
							// 		    tilt: 55,           //  轨迹播放的角度，默认为55
							// 		    duration: 500,    //  动画持续时长，默认为10000，单位ms
							// 		    delay: 1000          // 动画开始的延迟，默认0，单位ms
							// 		});
							// 		trackAni.start()
							// 		this.trackAniFlag = true	
							// 		newindex = i;
							// 	}
							// }
							
							let pl = new BMapGL.Polyline(linePoints, {
							  strokeColor: "#ff0000",
							  strokeWeight: 0, 
							});
							setTimeout(this.startAni(pl,len_path), 3000);							
						}else{
							that.$message({
								message: '轨迹长度不足',
								type: 'error'
							});
						}					
					}else{
						that.$message({
							message: '未获取到当前轨迹信息',
							type: 'error'
						});
					}
				})				
			},
			startAni(pl,len_path){
				trackAni = new BMapGLLib.TrackAnimation(bmap, pl, {
				    overallView: true,  // 动画完成后自动调整视野到总览
				    tilt: 35,           //  轨迹播放的角度，默认为55
				    duration: len_path * 100,    //  动画持续时长，默认为10000，单位ms
				    delay: 300          // 动画开始的延迟，默认0，单位ms
				});
				trackAni.start()
				this.trackAniFlag = true
			},
			pauseAni () {
			    trackAni.pause();
			},
			continueAni () {
			    trackAni.continue();
			},
			getColorByMode(dMode) {
			    if (dMode == 0) {
			        return "#00FF00"; 
			    } else {
			        return "#FF0000"; 
			    }
			},	
			bmapLushuStart(carid){
				getCarTraj(carid).then(res =>{
					let that = this
					
					if(res.result == 0){
						let tracklst = res.carTrajList 
						if(tracklst!=null && tracklst.length > 3){
							let accPoints = [];
							//去掉第一条值，从第二条数据开始取值
							for (let i = 0; i < tracklst.length; i++) {
							  var x = tracklst[i].baiduLongitude;
							  var y = tracklst[i].baiduLatitude;
							  
							  if (x == 0 || y == 0) {
							    continue;
							  }
							  var points = [] 
							  points[i] = new BMapGL.Point(x, y); //经纬度点并格式化点为BMap点
							  accPoints.push(points[i]);
							}
							
							if(accPoints==null || accPoints.length == 0){
								 console.log("轨迹数据长度不够");
								
								 this.$message({
								   message:"轨迹数据长度不够",
								   type: 'warn'
								 });
								 return;
							}
							
							//目标icon
							let accIcon = new BMapGL.Icon(require('../assets/img/car_track.png'), new BMapGL.Size(45, 46), {
							  // anchor: new BMap.Size(20, 20),
							  imageSize: {
							    width: 45,
							    height: 45
							  },
							});
							
							let polyline = new BMapGL.Polyline(accPoints, {
							  strokeColor: "#DC143C",
							  strokeWeight: 10
							});
							bmap.addOverlay(polyline); //添加轨迹到地图
							
							// 设置轨迹
							bmlLushu_path = new BMapLib.LuShu(bmap, accPoints, { // let lushu
							  defaultContent: ''+carid, 
							  speed: 10, //速度，单位米每秒
							  icon: accIcon, //声明高铁标注						  
							  autoView: true, //是否开启自动视野调整，如果开启那么路书在运动过程中会根据视野自动调整
							  enableRotation: false, // 是否设置marker随着道路的走向进行旋转，默认为false，即不随路走向旋转
							  landmarkPois: ''
							});
							bmap.setCenter(accPoints[0])
							bmlLushu_path.start(); // lushu.start();
							bmlLushu_play = true;
						}
					}	
				///	
				})	
			},		
			/** 时间计时 **/
			timeFn() {
				let that = this
				setInterval(() => {
					that.dateDay = formatTime(new Date(), 'HH: mm: ss');
					that.dateYear = formatTime(new Date(), 'yyyy-MM-dd');
					that.dateWeek = that.weekday[new Date().getDay()];
				}, 1000)
			},
			logout() {
				localStorage.setItem('username', '');
				localStorage.setItem('entityid', '');
				console.log("点击退出")
				this.$router.replace({
					name: 'login'
				})
			},	
			initFullScreen() {
				if (screenfull.enabled) {
					// screenfull.request(); // 并不支持默认全屏显示
					screenfull.on("change", this.changeFullScreen);
				}
			},
			changeFullScreen() {
				this.isFullscreen = screenfull.isFullscreen;
			},
			toggleFullScreen() {
				if (!screenfull.enabled) {
					// 如果不允许进入全屏，发出不允许提示
					alert('您的浏览器版本过低，不支持全屏浏览')
					return false;
				}
				screenfull.toggle();		
			},		
			// 获取天气
			 getWeather(){	 
				 
				 // var weatherService = new BMapLib.WeatherService();
				 // // 通过IP定位或指定城市查询当前天气情况
				 // weatherService.getLiveWeather({
				 //     location: '北京', // 根据所需城市名称修改城市名称
				 // }, function (data) {
				 //     if (data && data.status === 0) {
				 //         var currentCity = data.currentCity;
				 //         var temperature = data.temperature + '℃';
				 //         var weatherDesc = data.weatherDesc[0].value;
				         
				 //         // 更新天气信息到页面上的容器元素
				 //   //       document.getElementById('weatherContainer').innerHTML = 
					// 		// '<h4>' + currentCity + '</h4><p>温度：' + temperature + '</p><p>天气状态：' + weatherDesc + '</p>';
				 //     } else {
				 //         alert('无法获取天气信息');
				 //     }
				 // });
				 
				 
			// 	// let location = this.entitylocation
			// 	if(location != null){
			// 		// axios({
			// 		//     method: "get",
			// 		//     url:"https://api.map.baidu.com/weather/v1/?location="+location+"&data_type=all&ak=c285EvoFwodyUsTDY4sGiGV1",
			// 		// 	dataType: "JSONP"
			// 		// }).then((res) => {
			// 		//     this.weatherinfo.temperature = res.data.temp;
			// 		//     this.weatherinfo.weather = res.data.text;
			// 		// });	
						
			// 		this.$jsonp(
			// 			// "https://api.map.baidu.com/weather/v1/?location="+location+"&data_type=all&ak=c285EvoFwodyUsTDY4sGiGV1",
			// 			"http://api.map.baidu.com/telematics/v3/weather",
			// 		    {
			// 		       location: "北京市", 
			// 		       output: "json",
			// 		       ak: "c285EvoFwodyUsTDY4sGiGV1" 
			// 		    }
			// 		).then(res=> {
			// 		    this.weatherinfo.temperature = res.data.temp;
			// 		    this.weatherinfo.weather = res.data.text;
			// 		})	
								
			// 	}
			}
		}
	}
	
</script>

<style lang="scss" scoped>
	
	.bmap_comtainer{
		width: 100%;
		height: 100%;
	}
	
	.title_container{
		position: fixed;
		z-index: 1000;
		top: 0;
	    width:100%;
		height:8%;
		color: #fff;	
		background:rgba(22,26,99,.8);
		.logo-title{
			position: fixed;
			top: 2%;
			left: 1%;
			height: .6rem;
		}
		.selectchoose{
			position: fixed;
			top: 3%;
			left: 12%;
			.selector{
				width: 3rem;
				height: 0.4rem;
			}
		}
		
		.title{
			display: flex;
			flex-direction: row;
			justify-content: center;
			.title_text{
				font-family: "PingFang SC";	
				font-size: .3rem;
				font-weight: bold;
				letter-spacing: 0.05rem;
			}
		}
			
		.date{
			position: fixed;
			top: 2%;
			right: 1%;
			display: flex;
			flex-direction: column;
			font-family: Arial;
			font-weight: bold;
			letter-spacing: 0rem;
			text-align: right;
			color: #fff;
			.row1{
				display: flex;
				flex-direction: row;
				
				.title_text{
					font-size: .18rem;	
					align-self: center;
				}
				.btn-fullscreen {
					display: inline-block;
					margin:.1rem 0 .1rem .2rem;	
					.img1:hover {
						 content: url(../assets/img/screen_full_hover.png)
					}
					.img2:hover {						
						 content: url(../assets/img/screen_cancel_hover.png)
					}
				}
				.back_text{
					color: #19F2EB;
					font-size: .18rem;
					align-self: center;
					padding-left: .2rem;
					padding-right: .05rem;;
				}
				.btn_text{
					font-size: .18rem;	
					align-self: center;
					padding-left: .1rem;
					padding-right: .05rem;;
				}
			}
		}	
		
	}
	
	.body_container{
		position: absolute;
		top: 8%;
		left:0;	
	}
	
	.aniTrack_container{
		position: fixed;
		z-index: 999;
		top:53%;
		right: 26%;
		.btn3{
			height: .3rem;
			width: .5rem;
			padding: 0 0.1rem;
		}
	}
	

</style>
